webpackJsonp([70],{

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1385);


/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(857);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1384]);


// WEBPACK FOOTER //
// app/datetime.pt-d4d4e92fbe757ef2b885.js